// Each gene is a float in [min, max]. Values drive behavior weights
// and visual variation. All mutations clamp back to the gene's range.

export const GENES = {
  speed:       [0.65, 1.35],   // MAX_SPEED multiplier
  curiosity:   [0.05, 1.0],    // wander radius scale
  sociability: [0.0, 1.0],     // tendency to approach other cats
  playfulness: [0.0, 1.0],     // tendency to chase the ball
  restfulness: [0.05, 0.9],    // probability weight for "rest"
  size:        [0.8, 1.2],     // scale multiplier
}

const KEYS = Object.keys(GENES)

function clamp(v, [min, max]) {
  return Math.max(min, Math.min(max, v))
}

export function randomGenome() {
  const g = {}
  for (const k of KEYS) {
    const [min, max] = GENES[k]
    g[k] = min + Math.random() * (max - min)
  }
  return g
}

export function mutateGenome(g, strength = 0.1) {
  const out = {}
  for (const k of KEYS) {
    const range = GENES[k]
    const span = range[1] - range[0]
    out[k] = clamp((g[k] ?? (range[0] + range[1]) / 2) + (Math.random() - 0.5) * 2 * strength * span, range)
  }
  return out
}

export function crossGenome(a, b, mutationStrength = 0.07) {
  const out = {}
  for (const k of KEYS) {
    const range = GENES[k]
    const span = range[1] - range[0]
    // Uniform crossover + slight blend, then mutate
    const pick = Math.random() < 0.5 ? a[k] : b[k]
    const blended = pick * 0.75 + ((a[k] + b[k]) / 2) * 0.25
    out[k] = clamp(blended + (Math.random() - 0.5) * 2 * mutationStrength * span, range)
  }
  return out
}

// Sanitize a possibly-malformed saved genome (handles schema drift)
export function repairGenome(g) {
  if (!g || typeof g !== 'object') return randomGenome()
  const out = {}
  for (const k of KEYS) {
    const range = GENES[k]
    const v = typeof g[k] === 'number' ? g[k] : (range[0] + range[1]) / 2
    out[k] = clamp(v, range)
  }
  return out
}
